export default __webpack_public_path__ + "static/media/about-footer-mail.e9966bfa.svg";